import { HttpClient, HttpBackend, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { ApprovalRequestExternalCertificateSummaryModel } from '../models/approval-request/approval-request-external-certificate-summary.model';
import { ApprovalRequestExternalCertificateCreationAndUpdateModel } from "../models/approval-request/approval-request-external-certificate-creation-and-update.model";
import { DeclineMessageModel } from "../models/decline-message.model";
import { ExternalCertificateReviewModel } from "../models/approval-request/external-certificate-review.model";

@Injectable({
  providedIn: 'root'
})
export class ApprovalRequestService {

  constructor(private httpClient: HttpClient) {
  }

  public getApprovalRequestExternalCertificates(personId: string): Observable<ApprovalRequestExternalCertificateSummaryModel[]> {
    const params = new HttpParams()
      .set('personId', personId);

    return this.httpClient.get<ApprovalRequestExternalCertificateSummaryModel[]>(
      Configuration.getApiBaseUrl() + "/approvalrequest/external-certificate" , 
       { params: params }
    );
  }

  public addApprovalRequestExternalCertificate(model: ApprovalRequestExternalCertificateCreationAndUpdateModel): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + "/approvalrequest/external-certificate" , 
      model
    );
  }

  public updateApprovalRequestExternalCertificate(
    id: string, 
    model: ApprovalRequestExternalCertificateCreationAndUpdateModel
  ): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + "/approvalrequest/" + id + '/external-certificate', 
      model
    );
  }

  public deleteApprovalRequestExternalCertificate(id: string): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() + "/approvalrequest/" + id + '/external-certificate', 
    );
  }

  public reviewExternalCertificate(id: string, model: ExternalCertificateReviewModel): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + "/approvalrequest/" + id + "/review", 
      model
    );
  }

  public declineApprovalRequest(id: string, model: DeclineMessageModel): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + "/approvalrequest/" + id + "/decline", 
      model
    );
  }

  public deleteCertificateFile(id: string): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() +  '/approvalrequest/' + id + '/file'
    );
  }
}